export default {
  addNotification({ commit }, notification) {
    commit('ADD_NOTIFICATION', notification)
  },
}
